import { createTheme } from '@mui/material/styles'

// A custom theme for this app
const theme = createTheme({
  cssVariables: true,
  spacing: 6,
  palette: {
    brand: {
      main: '#8BC540',
      light: '#EAFBD9',
      dark: '#51924B',
    },
    primary: {
      main: '#333333',
    },
    secondary: {
      main: '#eeeeee',
      dark: '#dddddd',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.5)',
    },
    divider: '#e0e0e0',
    pickup: '#ffe0b2',
    delivery: '#90caf9',
  },
  typography: {
    fontFamily: '"DM Sans", sans-serif',
    fontSize: 14,
    body2: {
      color: '#808080',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          }
        }),
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.palette.divider,
          fontSize: '1rem',
        }),
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        title: {
          fontSize: '1.25rem',
        },
      },
    },
  },
})

export default theme
